<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.billingSurname' | translate }}
  </label>
  <input type="text" class="form-control" id="billingSurname" formControlName="billingSurname"  [ngClass]="{ 'is-invalid': campaignForm.get('billingSurname')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
